import { useEffect, useRef, useState } from "react";
import classes from "./ClinicianComponent.module.css";
import HPWeeklyTimingTabs from "../clinciantiming/HPWeeklyTimingTabs";
import PaymentHistory from "../../payment/PaymentHistory";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import OrganzationMain from "../../organzation/OrganizationMain";
import ClinicianMain from "./ClinicianMain";
import ServiceComponent from "../../service/servicemain/ServiceComponent";
import ServicesInformation from "../../service/servicedetails/ServicesInformation";
import WelcomePack from "../../../viewplans/WelcomePack";
import QrCode from "../QrCode/QrCode";
import { getRequest } from "../../../../api/AxiosAPICall";
import {
  Alert,
  AlertTitle,
  Grid,
  Stack,
  Typography,
  Link,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";

const ClinicianComponent = (props: any) => {
  let history = useNavigate();
  const [alignment, setAlignment] = useState("");
  const location = useLocation();
  const [mode, setMode] = useState("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isUserHp, setIsUserHp] = useState<boolean>(false);
  const [isShowPaymentPage, setIsShowPaymentPage] = useState(0);
  const [expiryDate, setExpiryDate] = useState("");
  const [isExpiryAlertSeen, setIsExpiryAlertSeen] = useState(false);
  const [isPlanExpired, setPlanExpired] = useState(false);
  const [isRenew, setIsRenew] = useState(false);
  const isMounted = useRef<any>(false);
  const [isSubscriptionSortedDate, setIsSubscriptionSortedDate] =
    useState(false);
  const { subscriptionSortedDate } = useSelector(
    (state: any) => state.paymentSortedDate
  );
  let latestDate = localStorage.getItem("subscriptionDate");

  let alertStartDate: string | null = null;

  if (expiryDate !== "" && expiryDate !== undefined) {
    alertStartDate = moment(expiryDate).fromNow();
  } else if (subscriptionSortedDate !== undefined) {
    alertStartDate = moment(subscriptionSortedDate).fromNow();
  }

  let formattedDate: string = "";

  if (expiryDate !== "" && expiryDate !== undefined) {
    formattedDate = moment(expiryDate).format("DD/MM/YYYY");
  } else if (subscriptionSortedDate !== undefined) {
    formattedDate = moment(subscriptionSortedDate).format("DD/MM/YYYY");
  }

  if (location?.state?.mode === undefined) {
    history("/unauthenticatedUser");
  }

  const getShowPaymentPage = async () => {
    const response = await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "show_cellmaflex_payment_page",
      },
    });
    setIsShowPaymentPage(response.data);
  };

  useEffect(() => {
    isMounted.current = true;
    getShowPaymentPage();
    if (
      alertStartDate === null ||
      (alertStartDate?.includes("ago") && isShowPaymentPage === 1)
    ) {
      setPlanExpired(true);
    }
    let show: any;

    if (localStorage.getItem("show") != null) {
      show = localStorage.getItem("show");
    }
    if (location?.state?.mode !== undefined) {
      setMode(location.state.mode);
    }
    if (
      (location?.state?.isAdminUser !== undefined &&
        String(location?.state?.isAdminUser) === "true") ||
      (show !== undefined && String(show) === "true")
    ) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (
      location?.state?.isUserHp !== undefined &&
      String(location?.state?.isUserHp) === "true"
    ) {
      setIsUserHp(true);
    } else {
      setIsUserHp(false);
    }

    if (latestDate !== undefined && latestDate !== null) {
      setExpiryDate(latestDate);
    }

    if (
      subscriptionSortedDate !== null &&
      subscriptionSortedDate !== undefined &&
      subscriptionSortedDate !== "" &&
      !moment(subscriptionSortedDate).fromNow().includes("ago")
    ) {
      setIsSubscriptionSortedDate(true);
      setExpiryDate("");
    }
    return () => {
      isMounted.current = false;
      setPlanExpired(false);
    };
    // eslint-disable-next-line
  }, [
    location,
    history,
    isShowPaymentPage,
    isAdmin,
    expiryDate,
    subscriptionSortedDate,
  ]);

  useEffect(() => {
    if (
      location?.state?.isAdminUser !== undefined &&
      String(location?.state?.isAdminUser) === "true" &&
      ((latestDate !== null && moment(latestDate).fromNow().includes("ago")) ||
        latestDate === null)
    ) {
      setAlignment("payment");
      setIsSubscriptionSortedDate(false);
    } else {
      setAlignment("userservice");
      setIsSubscriptionSortedDate(true);
    }
  }, [location, latestDate]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
    setIsRenew(false);
  };

  const style = {
    toggleStyle: {
      height: { xs: "45px", sm: "45px", md: "50px" },
      fontSize: { xs: "14px", sm: "14px", md: "15px" },

      borderTopLeftRadius: "4px !important",
      padding: "10px !important",
      "&.Mui-selected": {
        color: "#fff !important",
        backgroundColor: "#117CB1 !important",
        pointerEvents: "none !important",
        selected: true,
      },
      "&:hover": {
        color: "black",
        backgroundColor: "#b6d3df",
      },
    },
  };
  return (
    <CommonLayout>
      <Stack spacing={1} direction="column">
        {isAdmin && (
          <ToggleButtonGroup
            sx={{
              justifyContent: "center",
              display: { xs: "grid", sm: "inline-flex", md: "inline-flex" },
            }}
            color="primary"
            value={alignment}
            exclusive
            onChange={handleChange}
          >
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="userservice">
                <Typography className={classes.typography}>
                  User Information
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && isUserHp && (
              <ToggleButton sx={style.toggleStyle} value="clinicianscheduling">
                <Typography className={classes.typography}>
                  HP Appointment Schedule
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="organzation">
                <Typography className={classes.typography}>
                  Organization Information
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="service">
                <Typography className={classes.typography}>
                  Clinic Information
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="servicesInformation">
                <Typography className={classes.typography}>
                  Service Information
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="qrcode">
                <Typography className={classes.typography}>QR Code</Typography>
              </ToggleButton>
            )}
            {isShowPaymentPage === 1 && (
              <ToggleButton sx={style.toggleStyle} value="payment">
                <Typography className={classes.typography}>
                  Payment History
                </Typography>
              </ToggleButton>
            )}

            <ToggleButton sx={style.toggleStyle} value="welcomepack">
              <Typography className={classes.typography}>Learn More</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        )}

        {!isAdmin && (
          <ToggleButtonGroup
            sx={{
              justifyContent: "center",
              display: { xs: "grid", sm: "inline-flex", md: "inline-flex" },
            }}
            color="primary"
            value={alignment}
            exclusive
            onChange={handleChange}
          >
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="userservice">
                <Typography className={classes.typography}>
                  User Information
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && isUserHp && (
              <ToggleButton sx={style.toggleStyle} value="clinicianscheduling">
                <Typography className={classes.typography}>
                  HP Appointment Schedule
                </Typography>
              </ToggleButton>
            )}
            {!isPlanExpired && isSubscriptionSortedDate && (
              <ToggleButton sx={style.toggleStyle} value="qrcode">
                <Typography className={classes.typography}>QR Code</Typography>
              </ToggleButton>
            )}

            <ToggleButton sx={style.toggleStyle} value="welcomepack">
              <Typography className={classes.typography}>Learn More</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        )}

        <Grid container sx={{ display: "flex", justifyContent: "center" }}>
          {(alertStartDate === "in 10 days" ||
            alertStartDate === "in 9 days" ||
            alertStartDate === "in 8 days" ||
            alertStartDate === "in 7 days" ||
            alertStartDate === "in 6 days" ||
            alertStartDate === "in 5 days" ||
            alertStartDate === "in 4 days" ||
            alertStartDate === "in 3 days" ||
            alertStartDate === "in 2 days" ||
            alertStartDate === "in a day" ||
            alertStartDate?.includes("hours")) &&
            !isExpiryAlertSeen &&
            !alertStartDate?.includes("ago") && (
              <Grid item xs={6}>
                <Alert
                  severity="info"
                  onClose={() => setIsExpiryAlertSeen(true)}
                >
                  <AlertTitle>
                    <strong>Your subscription will expire soon</strong>
                  </AlertTitle>
                  Your cellmaflex subscription will expire
                  <strong> {alertStartDate.toString()}</strong>.
                </Alert>
              </Grid>
            )}
          {alertStartDate?.includes("ago") && (
            <Grid item xs={6}>
              <Alert severity="warning">
                <AlertTitle>
                  <strong>Your subscription has expired</strong>
                </AlertTitle>
                Your cellmaflex subscription has expired on{" "}
                <strong>{formattedDate}</strong>{" "}
                <Link
                  className={classes.isRenewLink}
                  onClick={() => {
                    setIsRenew(true);
                    setAlignment("payment");
                  }}
                >
                  Please renew
                </Link>
              </Alert>
            </Grid>
          )}
        </Grid>

        {alignment === "organzation" && <OrganzationMain mode={mode} />}
        {alignment === "userservice" && location?.state?.mode !== undefined && (
          <ClinicianMain />
        )}
        {alignment === "clinicianscheduling" &&
          location?.state?.mode !== undefined && <HPWeeklyTimingTabs />}
        {alignment === "service" && <ServiceComponent />}
        {alignment === "servicesInformation" && (
          <ServicesInformation mode={mode} />
        )}
        {alignment === "payment" && (
          <PaymentHistory
            isRenew={isRenew}
            handleMakePayment={() => setIsRenew(true)}
            handleShowPaymentHistory={() => setIsRenew(false)}
          />
        )}
        {alignment === "welcomepack" && isRenew === false && <WelcomePack />}

        {alignment === "qrcode" && <QrCode />}
      </Stack>
    </CommonLayout>
  );
};

export default ClinicianComponent;
